export const projectId = '6d3bc04f-0792-4581-83d4-98f2cbe62fa1'
export const predictionKey = '65b1a8c7954f4419ad7016e6e7fccb27'
export const predictionResourceId = '/subscriptions/a66234c8-7533-4e74-868f-83f6bad2a4cf/resourceGroups/OperationCapybara/providers/Microsoft.CognitiveServices/accounts/CodeCapybara'
export const endPoint = 'https://codecapybara.cognitiveservices.azure.com/'
export const publishIterationName = 'Iteration3'
